import { render, staticRenderFns } from "./DocumentGeneralInfo.vue?vue&type=template&id=6b175ce0&scoped=true&"
import script from "./DocumentGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./DocumentGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./DocumentGeneralInfo.vue?vue&type=style&index=0&id=6b175ce0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b175ce0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b175ce0')) {
      api.createRecord('6b175ce0', component.options)
    } else {
      api.reload('6b175ce0', component.options)
    }
    module.hot.accept("./DocumentGeneralInfo.vue?vue&type=template&id=6b175ce0&scoped=true&", function () {
      api.rerender('6b175ce0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/detailPages/supplierDetailPages/DocumentGeneralInfo.vue"
export default component.exports